import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {sendLoginLinkEmail} from 'src/openapi/admin/apis/UsersEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useLoginLinkEmail = ({userId, onFail, onSuccess}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        sendLoginLinkEmail({userId}),
    ), [userId, apiDispatch]);

    return useCommonEventHook({eventAction, onFail, onSuccess});
};
